module.exports = __webpack_public_path__ + "img/question.75621d7b.png";